export const fonts = {
    fontFamily: 'Usual',
    fontFamilyTitle: 'Usual',
}